import { IconSvgProps } from '../../../../../components/Icon/Icon';
import BaseLibraryIconSvg from '../../../../../components/Icon/BaseLibraryIconSvg';

export default function LinkedIn(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg {...props}>
      <g clipPath='url(#clip0_5463_49216)'>
        <path
          d='M4 3H20C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3ZM5 5V19H19V5H5ZM7.5 9C7.10218 9 6.72064 8.84196 6.43934 8.56066C6.15804 8.27936 6 7.89782 6 7.5C6 7.10218 6.15804 6.72064 6.43934 6.43934C6.72064 6.15804 7.10218 6 7.5 6C7.89782 6 8.27936 6.15804 8.56066 6.43934C8.84196 6.72064 9 7.10218 9 7.5C9 7.89782 8.84196 8.27936 8.56066 8.56066C8.27936 8.84196 7.89782 9 7.5 9ZM6.5 10H8.5V17.5H6.5V10ZM12 10.43C12.584 9.865 13.266 9.5 14 9.5C16.071 9.5 17.5 11.179 17.5 13.25V17.5H15.5V13.25C15.5 12.7859 15.3156 12.3408 14.9874 12.0126C14.6592 11.6844 14.2141 11.5 13.75 11.5C13.2859 11.5 12.8408 11.6844 12.5126 12.0126C12.1844 12.3408 12 12.7859 12 13.25V17.5H10V10H12V10.43Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_5463_49216'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </BaseLibraryIconSvg>
  );
}
